var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-layout-grid',[_c('filter-section',{on:{"reset-pagination":_vm.resetPagination}}),_c('header-section'),_c('main-section-pr-ec'),(_vm.dataLoaded && _vm.isEquityTenant)?_c('pagination-section',{ref:"paginationSection",attrs:{"dataLength":_vm.dataLength},on:{"page-changed":_vm.handlePageChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }